import type { NotificationSettings } from './types';

export const DEFAULT_NOTIFICATION_SETTINGS: NotificationSettings = {
  enabled: true,
  volume: 0.7,
  soundPack: 'aurora',
  playOn: {
    workComplete: true,
    breakComplete: true,
    planStart: true,
  },
};

const clampVolume = (value: unknown) => {
  if (typeof value !== 'number' || !Number.isFinite(value))
    return DEFAULT_NOTIFICATION_SETTINGS.volume;
  return Math.min(Math.max(value, 0), 1);
};

const booleanOrDefault = (value: unknown, fallback: boolean) =>
  typeof value === 'boolean' ? value : fallback;

export const normalizeNotificationSettings = (value: unknown): NotificationSettings => {
  if (!value || typeof value !== 'object') return DEFAULT_NOTIFICATION_SETTINGS;
  const settings = value as Partial<NotificationSettings>;
  const playOn =
    settings.playOn && typeof settings.playOn === 'object'
      ? (settings.playOn as Partial<NotificationSettings['playOn']>)
      : {};

  return {
    enabled: booleanOrDefault(settings.enabled, DEFAULT_NOTIFICATION_SETTINGS.enabled),
    volume: clampVolume(settings.volume),
    soundPack:
      typeof settings.soundPack === 'string' && settings.soundPack.trim()
        ? settings.soundPack.trim()
        : DEFAULT_NOTIFICATION_SETTINGS.soundPack,
    playOn: {
      workComplete: booleanOrDefault(
        playOn.workComplete,
        DEFAULT_NOTIFICATION_SETTINGS.playOn.workComplete,
      ),
      breakComplete: booleanOrDefault(
        playOn.breakComplete,
        DEFAULT_NOTIFICATION_SETTINGS.playOn.breakComplete,
      ),
      planStart: booleanOrDefault(playOn.planStart, DEFAULT_NOTIFICATION_SETTINGS.playOn.planStart),
    },
  };
};
